import HostUrl from '@/utils/HostUrl.js'

let hostUrl = new HostUrl()

let host = hostUrl.getUrl(''),
  goods_host = hostUrl.getUrl('GOODS'),
  oms_host = hostUrl.getUrl('OMS'),
  scm_host = hostUrl.getUrl('SCM'),
  task_host = hostUrl.getUrl('REPORT'),
  region_host = hostUrl.getUrl('REGION'),
  shop_host = hostUrl.getUrl('SHOP'),
  order_host = hostUrl.getUrl('ORDER'),
  inventory_host = hostUrl.getUrl('INVENTORY'),
  idaas_host = hostUrl.getUrl('IDAAS'),
  express_host = hostUrl.getUrl('EXPRESS')

export default {
  getDownloadKey: host + '/oauth/download/key', //获取临时下载的key
  filePreUpload: `${host}/ossapi/file/preUploadFile`, // oss预上传
  // scm_host
  warehouseList: scm_host + '/warehouse/list', // 仓库列表页
  batchSavePurchaseOrder: scm_host + '/purchaseOrder/batchSave', // 批量导入采购单
  purchaseOrderList: scm_host + '/purchaseOrder/list', // 采购订单列表页
  batchCancelPurchaseOrder: scm_host + '/purchaseOrder/batchCancel', // 批量作废采购单
  batchCheckPurchaseOrder: scm_host + '/purchaseOrder/batchCheck', // 批量审核采购单
  batchFinishPurchaseOrder: scm_host + '/purchaseOrder/batchFinish', // 批量完结采购单
  getSkuList: goods_host + '/sku/query',
  skuListForScm: goods_host + '/goods/skuListForScm',
  purchaseOrderSave: scm_host + '/purchaseOrder/save', // 新增采购订单
  purchaseOrderDetail: scm_host + '/purchaseOrder/detail', // 采购订单详情页
  updatePurchaseOrderInfo: scm_host + '/purchaseOrder/updatePurchaseOrderInfo', //修改采购订单基本信息
  updatePurchaseOrderItems: scm_host + '/purchaseOrder/updatePurchaseOrderItems', // 修改采购订单商品信息
  purchaseOrderCheck: scm_host + '/purchaseOrder/check', // 审核采购单
  purchaseOrderCancel: scm_host + '/purchaseOrder/cancel', // 作废采购单
  purchaseOrderFinish: scm_host + '/purchaseOrder/finish', // 完结采购单
  autoCreateAsn: scm_host + '/purchaseOrder/autoCreateAsn', // 采购单自动创建ASN
  advancedShippingNote: scm_host + '/advancedShippingNote/list', // 预到货通知单列表页
  advancedShippingNoteBatchCheck: scm_host + '/advancedShippingNote/batchCheck', // 批量审核预到货通知单
  advancedShippingNoteCheck: scm_host + '/advancedShippingNote/check', // 审核预到货通知单
  advancedShippingNoteBatchCancel: scm_host + '/advancedShippingNote/batchCancel', // 批量作废预到货通知单
  advancedShippingNoteCancel: scm_host + '/advancedShippingNote/cancel', // 作废预到货通知单
  advancedShippingNoteBatchFinish: scm_host + '/advancedShippingNote/batchFinish', // 批量完结预到货通知单
  advancedShippingNoteRevertCheck: scm_host + '/advancedShippingNote/revertCheck', //退审
  advancedShippingNoteFinish: scm_host + '/advancedShippingNote/finish', // 完结预到货通知单
  listBySearchForASN: scm_host + '/purchaseOrder/listBySearchForASN', // ASN搜索采购单
  getByPOIdForASN: scm_host + '/purchaseOrder/getByPOIdForASN', // 通过采购单ID获取创建ASN信息
  advancedShippingNoteSave: scm_host + '/advancedShippingNote/save', // 新增预到货通知单
  advancedShippingNoteDetail: scm_host + '/advancedShippingNote/detail', // 预到货通知单详情页
  updateAdvancedShippingNoteInfo: scm_host + '/advancedShippingNote/updateAdvancedShippingNoteInfo', // 修改预到货通知单基本信息
  updateAsnEstimatedArrivalTime: scm_host + '/advancedShippingNote/updateAsnEstimatedArrivalTime', // 修改ASN预计到货时间
  advancedShippingNoteUpdateMemo: scm_host + '/advancedShippingNote/updateMemo', // 修改预到货通知单备注
  updateAdvancedShippingNoteItems:
    scm_host + '/advancedShippingNote/updateAdvancedShippingNoteItems', // 修改预到货通知单商品信息
  purchaseOrderActionList: scm_host + '/purchaseOrderAction/list', // 查询采购单操作日志
  advancedShippingNoteActionList: scm_host + '/advancedShippingNoteAction/list', // 查询预到货通知单操作日志
  batchRetryPushAsn: scm_host + '/advancedShippingNote/batchRetryPushAsn', // 批量手动推送asn
  purchaseOrderExport: scm_host + '/purchaseOrder/export', // 批量导出采购单信息
  advancedShippingNotebatchSave: scm_host + '/advancedShippingNote/batchSave', //批量录入预到货通知单
  exportShippingMark: scm_host + '/advancedShippingNote/exportShippingMark', //导出箱唛pdf
  shippingMarkPreview: scm_host + '/page/asn/shippingMarkPreview', //箱唛预览
  advancedShippingNoteExport: scm_host + '/advancedShippingNote/export', //批量导出
  batchImportPurchaseOrderItems: scm_host + '/purchaseOrder/batchImportPurchaseOrderItems', //导入采购单商品信息
  batchImportAdvancedShippingNoteItems:
    scm_host + '/advancedShippingNote/batchImportAdvancedShippingNoteItems', //导入预到货通知单商品信息
  purchaseOrderSnPrefixList: scm_host + '/supplyChainConfig/purchaseOrderSnPrefixList', //查询业务组采购单前缀
  updatePurchaseOrderSnPrefix: scm_host + '/supplyChainConfig/updatePurchaseOrderSnPrefix', //修改业务组采购单前缀
  supplyChainConfigPoTemplateList: scm_host + '/supplyChainConfig/poTemplateList', //查询商户品牌模板配置列表 isSelected: true代表当前选中
  updatePOTemplateConfig: scm_host + '/supplyChainConfig/updatePOTemplateConfig', //修改商户品牌模板配置
  // 调拨
  transferOrderList: scm_host + '/transferOrder/list', //调拨单列表
  transferOrderSave: scm_host + '/transferOrder/save', //创建调拨单
  transferOrderDetail: scm_host + '/transferOrder/detail', //调拨单详情
  transferOrderUpdateTransferOrderInfo: scm_host + '/transferOrder/updateTransferOrderInfo', //更新调拨信息
  transferOrderUpdateTransferOrderItems: scm_host + '/transferOrder/updateTransferOrderItems', //更新商品信息
  transferOrderCheck: scm_host + '/transferOrder/check', //审核
  transferOrderCancel: scm_host + '/transferOrder/cancel', //作废
  batchTransferOrderPush: scm_host + '/transferOrder/batchPush', //推送
  transferOrderAction: scm_host + '/transferOrderAction/list', //推送
  advancedShippingNoteSearchItemsByBatchNo: scm_host + '/advancedShippingNote/searchItemsByBatchNo', //根据批次号搜索asnItems
  advancedShippingNoteBatchImportAsnPutAwayQuantity:
    scm_host + '/advancedShippingNote/batchImportAsnPutAwayQuantity', //批量导入到货数量
  advancedShippingNoteConfirmNewAsnInfoByVirtualWms:
    scm_host + '/advancedShippingNote/confirmNewAsnInfoByVirtualWms', //虚拟仓手动入库
  purchaseOrderExportPurchaseContract: scm_host + '/purchaseOrder/exportPurchaseContract', //导出采购合同
  // 供应商
  supplierList: scm_host + '/purchase/supplier/pageList', //供应商列表
  supplierDetail: scm_host + '/purchase/supplier/detail', //供应商详情
  supplierCreate: scm_host + '/purchase/supplier/create', //供应商创建
  supplierUpdate: scm_host + '/purchase/supplier/update', //供应商更新
  exportSupplier: scm_host + '/purchase/supplier/export', //供应商导出
  supplierBatchUpdateStatus: scm_host + '/purchase/supplier/batchUpdateStatus', //供应商状态批量更新
  getBizModeMap: scm_host + '/purchase/supplier/getBizModeMap', //合作模式列表
  getRegionAdd: region_host + '/region/all', //获取地址
  queryPurchaseSupplierList: scm_host + '/purchase/supplier/queryPurchaseSupplierList', //供应商名称列表
  initSupplierMerchant: scm_host + '/purchase/supplier/initSupplierMerchant', //生成供应商门户账号
  ossfileUpload: scm_host + '/ossfile/upload', //上传文件
  getWarehouseListByShopId: oms_host + '/warehouse/listByShop', // 根据店铺查找仓库
  getMerchantRefetList: `${idaas_host}/merchant/refer/list`, // 集团下供应商列表

  //采购退货
  supplierReturnOrderList: scm_host + '/supplierReturnOrder/list', //采购退货单列表
  supplierReturnOrderDetail: scm_host + '/supplierReturnOrder/detail', //采购退货单详情
  supplierReturnOrderSave: scm_host + '/supplierReturnOrder/save', //采购退货单保存
  updateSupplierReturnOrderInfo: scm_host + '/supplierReturnOrder/updateSupplierReturnOrderInfo', //采购退货单信息更新
  updateSupplierReturnOrderItems: scm_host + '/supplierReturnOrder/updateSupplierReturnOrderItems', //采购退货单商品列表
  supplierReturnOrderCheck: scm_host + '/supplierReturnOrder/check', //采购退货单审核
  supplierReturnOrderBatchCheck: scm_host + '/supplierReturnOrder/batchCheck', //采购退货单批量审核
  supplierReturnOrderCancel: scm_host + '/supplierReturnOrder/cancel', //采购退货单作废
  supplierReturnOrderBatchCancel: scm_host + '/supplierReturnOrder/batchCancel', //采购退货单批量作废
  supplierReturnOrderBatchPush: scm_host + '/supplierReturnOrder/batchPush', //采购退货单推送
  supplierReturnOrderActionList: scm_host + '/supplierReturnOrderAction/list', //采购退货单日志
  querySkuStock: scm_host + '/inventory/querySkuStock', //采购退货单库存
  batchImportSupplierReturnOrderGoods:
    scm_host + '/supplierReturnOrder/batchImportSupplierReturnOrderGoods', //采购退货单批量导入
  //平台退款
  platformRefundRefundableInfo: scm_host + '/platformRefund/refundableInfo', //查询可退款设备/退款金额
  platformRefundCreate: scm_host + '/platformRefund/create', //提交平台退款
  platformRefundList: scm_host + '/platformRefund/list', //平台退款单列表
  platformRefundSyncList: scm_host + '/platformRefund/sync/list', //手动同步平台退款记录
  taskCreate: task_host + '/task/create', //oms导出
  queryCategoryList: goods_host + '/category/list', //获取商品类目列表

  getUPDBrandList: goods_host + '/brand/list', //goods品牌列表
  querySkuRelationMap: goods_host + '/sku/relationMap', //商品供应商关系映射

  //采购计划
  queryProcurementPlanList: scm_host + '/procurementPlan/procurementPlanList', //采购计划列表
  queryPlatformList: scm_host + '/inventory/queryPlatformList', //平台列表

  updatePurchaseOrderPrice: scm_host + '/purchaseOrder/updatePurchaseOrderPrice', //供价调整

  queryPurchaseRequestList: scm_host + '/purchaseRequest/list', //采购申请单列表
  queryPurchaseRequestDetail: scm_host + '/purchaseRequest/detail', //采购申请单详情
  savePurchaseRequest: scm_host + '/purchaseRequest/save', //创建申请单列表
  reviewPurchaseRequest: scm_host + '/purchaseRequest/review', //审核申请单列表
  getDefaultRelation: scm_host + '/supplierGoodsRelation/getDefaultRelation', //查看商品默认供应商
  updatePurchaseRequestBaseInfo: scm_host + '/purchaseRequest/update', //采购申请单更新
  updatePurchaseRequestItems: scm_host + '/purchaseRequest/updateItems', //采购申请单更新
  firstCheckPurchaseRequest: scm_host + '/purchaseRequest/check/first', //采购申请单采购主管审核
  middleCheckPurchaseRequest: scm_host + '/purchaseRequest/check/middle', //采购申请单财务审核
  finalCheckPurchaseRequest: scm_host + '/purchaseRequest/check/final', //采购申请单CEO审核
  rejectPurchaseRequest: scm_host + '/purchaseRequest/reject', //采购申请单拒绝

  queryCommonActionList: scm_host + '/commonAction/list', //日志接口

  querySupplierGoodsRelationList: scm_host + '/supplierGoodsRelation/list', //商品供应商关系列表
  saveSupplierGoodsRelation: scm_host + '/supplierGoodsRelation/save', //商品供应商关系
  removeSupplierGoodsRelation: scm_host + '/supplierGoodsRelation/remove', //商品供应商关系

  updateTransferOrderItemInventoryInfo:
    scm_host + '/transferOrder/updateTransferOrderItemInventoryInfo', //更新调拨单商品库存信息

  updateSupplierReturnOrderItemInventoryInfo:
    scm_host + '/supplierReturnOrder/updateSupplierReturnOrderItemInventoryInfo', //更新采购退货单商品库存信息（指定批次发货）

  //shop接口
  getWarehouseListNew: shop_host + '/warehouse/queryWarehousePage', //仓库列表
  queryWarehousePageWithShipper: shop_host + '/warehouse/queryWarehousePageWithShipper', //仓库货主列表
  getWarehouseShipperList: shop_host + '/shipper/page', //货主列表
  saveShipperWarehouse: shop_host + '/warehouse/saveShipperWarehouse', //保存仓库货主关系
  listServiceProvider: shop_host + '/warehouse/listServiceProvider', //服务商列表
  getShippingListByShopAndWarehouse: `${shop_host}/shop/listShippingByShopAndWarehouse`, //快递列表

  getOrderGoodsInfo: order_host + '/out/order/outStockInfo',

  skuStockQuerySkuStock: inventory_host + '/skuStock/querySkuStockForOms', //查询barcode可用库存
  queryInventoryItemList: `${inventory_host}/skuStock/inventoryItemList`, //查询商品库存明细
  queryStockListSimple: `${inventory_host}/skuStock/stockListSimple`, //查询商品库存明细

  getCommonSetting: scm_host + '/commonSetting/get',
  setCommonSetting: scm_host + '/commonSetting/set',

  queryRegisterProgress: idaas_host + '/merchant/queryRegisterProgress', //查询商户注册进度
  getDepartmentList: idaas_host + '/open/department/listDepartment', //结算组织列表

  batchCreatePayable: scm_host + '/advancedShippingNote/batchCreatePayable', //创建应付单
  advancedShippingNoteUpdateImei: scm_host + '/advancedShippingNote/updateImei', // 更新ASN串码与入库图片
  queryShipmentList: `${express_host}/shipment/list`, // 获取物流轨迹
  queryTrackingRoute: `${scm_host}/route/supplierReturnOrder`, // 快递路由
}
